let barChart = null;
let camembertChart = null;
let camembertChart2= null;
let camembertChart3= null;

const reds   = ['#E74C3C', '#FF0000', '#FFA07A', '#FA8072', '#DC143C', '#F08080', '#CD5C5C', '#B22222', '#FF4500', '#8B0000'];
const blues  = ['#3498DB', '#0000FF', '#B0E0E6', '#87CEFA', '#00BFFF', '#E6E6FA', '#1E90FF', '#4682B4', '#000080', '#87CEEB'];
const greens = ['#2ECC71', '#7CFC00', '#32CD32', '#00FF00', '#228B22', '#006400', '#9ACD32', '#90EE90', '#3CB371', '#2E8B57'];

var stat = {

    loadcamembers(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, etat=1) {

        let b_colors = reds;
        if(etat == 0)
          b_colors = blues;
        if(etat == 2)
          b_colors = greens;

        jquery.ajax({
            url: backendUrl+"controller/stats.php",
            async: false,
            type: "POST",
            data: {
                'retard': 1,
                'dte_deb': dteDeb,
                'dte_fin': dteFin,
                'restriction': restrections,
                'vendeur': vendeur,
                'etat': etat,
                'include_histo': inclHisto
            },
            dataType: "html",
            success: function(data) {
                
                //console.log(data)
                let chart_height = 290;
                let chart_width = 200;
                if(document.body != null)
                   chart_width = document.body.offsetWidth*25/100;

                var dataParsed = JSON.parse(data)
                
                const vedeurs = dataParsed[0]
                stat.buildCamembertChart(vedeurs, document.getElementById('camembertChart'), 1, chart_width, chart_height, b_colors, "", "Commercial");

                const clients = dataParsed[1]
                stat.buildCamembertChart(clients, document.getElementById('camembertChart2'), 2, chart_width, chart_height, b_colors, "Clients", "Client");

                const objets = dataParsed[2]
                stat.buildCamembertChart(objets, document.getElementById('camembertChart3'), 3, chart_width, chart_height, b_colors, "Objets", "Objet");

                stat.buildBarChart(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, etat, document.getElementById('barChart'));
                
                          /*
                window.addEventListener( "resize", () => {
                    self.camembertChart.resize();self.camembertChart2.resize();self.camembertChart3.resize();self.barChart.resize();
                  }
                );*/
                
            }
        })

    },

    buildCamembertChart(data, node, num, chartwidth, chartheight, colors, cLabel, text) {

        const donneesCamembert = {
            labels: data[0],
            datasets: [{
              label: cLabel,
              data: data[1],
              backgroundColor: colors
            }],									
        };

        // Configuration du graphique camembert
        const configCamembert = {
            type: 'doughnut',
            data: donneesCamembert,
            options: {
                layout: {
                    padding: -30
                },
                responsive: false,
                plugins: {
                    legend: {
                        labels: {
                            boxWidth:16,
                            boxHeight:14,
                            font: {
                                size: 10
                            }
                        },
                        position: 'right',
                    },
                    title: {
                        display: true,
                        fullSize: false,
                        text: text,
                        color: '#e67e22',
                        font: {
                            size: 14
                        },
                        padding: {
                            top: 50
                        }
                    }
                },
            }
        };
        
        const ctc = node.getContext('2d');
        node.width = chartwidth;
        node.height = chartheight;

        if(num == 1) {
            if(camembertChart != null) camembertChart.destroy();
            camembertChart = new Chart(ctc, configCamembert);
        } else if(num == 2) {
            if(camembertChart2 != null) camembertChart2.destroy();
            camembertChart2 = new Chart(ctc, configCamembert);
        } else if(num == 3) {
            if(camembertChart3 != null) camembertChart3.destroy();
            camembertChart3 = new Chart(ctc, configCamembert);
        } 
    },

    buildBarChart(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, etat, node) {

        const nbrRetard = retardData[0];
        const nbrEnCour = retardData[1];
        const nbrClot   = retardData[2];

        const nbrRetards = nbrRetard+'                            ';
        const nbrEnCours = nbrEnCour+'                            ';
        const nbrClots   = nbrClot;

        const donneesBarChart = {
            labels: [""],
            datasets: [{label: 'Retards: '+ nbrRetards, data: [nbrRetard], backgroundColor: '#e74c3c'}, 
            {label: 'En cours: '+ nbrEnCours, data: [nbrEnCour], backgroundColor: '#3498db'}, 
            {label: 'Cloturé: '+ nbrClots, data: [nbrClot], backgroundColor: '#2ecc71'}],									
        };

        // Configuration du graphique bar
        const configBarChart = {
            type: 'bar',
            data: donneesBarChart,
            options: {
                onClick: function (evt, item) {
                    //console.log ('legend onClick', evt);
                    //console.log('item', item[0].datasetIndex);
                    if(item[0] != null) {
                        let indexc = item[0].datasetIndex;
                        if(indexc==0)
                            stat.loadcamembers(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, 1);
                        else if(indexc==1)
                            stat.loadcamembers(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, 0);
                        else
                            stat.loadcamembers(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, indexc);
                    }
                },
                layout: {
                    padding: -20
                },
                responsive: false,
                plugins: {
                    tooltip: {
                    callbacks: {
                        label: function(tooltipItems, data) {
                            return tooltipItems.dataset.label;
                        }
                    }
                    },
                    legend: {
                        labels:{boxWidth:15},
                        onClick : function (e, legendItem, legend){
                            let indexc = legendItem.datasetIndex;
                            if(indexc==0)
                                stat.loadcamembers(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, 1);
                            else if(indexc==1)
                                stat.loadcamembers(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, 0);
                            else
                                stat.loadcamembers(jquery, backendUrl, retardData, dteDeb, dteFin, restrections, vendeur, inclHisto, indexc);
                        }
                    },
                    title: {
                        display: true,
                        color: '#e67e22',
                        font: {
                            size: 14
                        }
                    }
                },
                scales: {
                    y: {
                        title: {
                            display: true,
                            text: '     '
                        }
                    }
                }
            }
        };
        const ctc4 = node.getContext('2d');
        node.width = (document.body.offsetWidth*40/100);
        if(barChart != null)
            barChart.destroy();
        barChart = new Chart(ctc4, configBarChart);
    }

}

export default stat